/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Dev_Loop_NoteInputs */

const en_marketing_dev_loop_note = /** @type {(inputs: Marketing_Dev_Loop_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D1, R2, Queues, DOs, crons, and workflows, simulated locally`)
};

const es_marketing_dev_loop_note = /** @type {(inputs: Marketing_Dev_Loop_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D1, R2, Queues, DOs, crons y flujos de trabajo, simulados localmente`)
};

const fr_marketing_dev_loop_note = /** @type {(inputs: Marketing_Dev_Loop_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D1, R2, Queues, DOs, crons et workflows, simulés en local`)
};

/**
* | output |
* | --- |
* | "D1, R2, Queues, DOs, crons, and workflows, simulated locally" |
*
* @param {Marketing_Dev_Loop_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_dev_loop_note = /** @type {((inputs?: Marketing_Dev_Loop_NoteInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Dev_Loop_NoteInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_dev_loop_note(inputs)
	if (locale === "es") return es_marketing_dev_loop_note(inputs)
	return fr_marketing_dev_loop_note(inputs)
});